import { Box, Typography } from "@mui/material";
import React from "react";

export default function InputGroupShape({ name, children, sx }) {
  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid #ccc",
        borderRadius: "5px",
        position: "relative",
        m: 1,
        ...sx,
      }}
    >
      {name && (
        <Typography
          sx={{
            position: "absolute",
            top: -20,
            left: 10,
            backgroundColor: "var(--app-surface)",
            p: 1,
          }}
        >
          {name}
        </Typography>
      )}
      {children}
    </Box>
  );
}
